module.exports = __webpack_public_path__ + "static/media/bdm-icons.6aeea5c8.ttf";